import { useLocation } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

export const useIsClientDocumentsRoute = () => {
  const { organization } = useUserOrganization()
  const { pathname } = useLocation()
  const clientDocumentsPath = getOrganizationViewUrl(
    organization?.url,
    reactRoute.organization.clientDocuments.getMainRoute(),
  )

  return !!clientDocumentsPath && (pathname === clientDocumentsPath || pathname.startsWith(`${clientDocumentsPath}/`))
}
